import React, { useState, useEffect, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import { Container, Row, Col, Modal } from 'react-bootstrap';

import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { DOWNLOADULD, GETTYPECODE, GETDESTINATION, GETCONDITIONCODE, GETOWNERCODE, GETDAMAGETYPE, FILTERRECEIVEDBY } from '../../../../Utils/conts.js';
import { toast } from 'react-toastify';

const DownloadGrid = ({ onClose, download_sec, download_area }) => {
    const isMounted = useRef(false);
    const [getTypeCodes, setGetTypeCodes] = useState([]);
    const [getOwnerCodes, setGetOwnerCode] = useState([]);
    const [getCondCodes, setGetCondCode] = useState([]);
    const [getTransfer, setGetTransfer] = useState([]);
    const [getDestination, setGetDestination] = useState([]);
    const [transferHandler, setTransferHandler] = useState([]);
    const [destinationHandler, setDestinationHandler] = useState([]);
    const [damageType, setDamageType] = useState([]);

    const [isModalOpen, setIsModalOpen] = useState(true);
    const [downloadData, setDownloadData] = useState({
        condition_code: [], status: [], origin: [], type_code: [], owner_code: [],
    });
    const options = [];

    const fetchTypeCode = async () => {
        try {

            const res = await withRFSToken.post(GETTYPECODE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.uld_typecode,
                        label: item.uld_typecode
                    })) : [];
                    setGetTypeCodes(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchOwnerCode = async () => {
        try {
            const res = await withRFSToken.post(GETOWNERCODE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.IATA,
                        label: item.IATA
                    })) : [];
                    setGetOwnerCode(transformedData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchCondCode = async () => {
        try {
            const res = await withRFSToken.post(GETCONDITIONCODE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? Object.entries(innerData).map(item => ({
                        value: item[0],
                        label: item[1]
                    })) : [];
                    setGetCondCode(transformedData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDestination = async () => {
        try {

            const res = await withRFSToken.post(GETDESTINATION, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.port_code,
                        label: item.port_code,
                        address: item.address
                    })) : [];
                    setGetDestination(transformedData);
                    setGetTransfer(transformedData)
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchReceivedBy = async () => {
        try {

            const res = await withRFSToken.post(FILTERRECEIVEDBY, { tab_name: download_sec })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.id,
                        label: item.company_name
                    })) : [];
                    setDestinationHandler(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDamageType = async () => {
        try {
            const res = await withRFSToken.post(GETDAMAGETYPE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // console.log("🚀 ~ .then ~ innerData:654", innerData)
                    setDamageType(innerData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    useEffect(() => {
        if (isMounted.current) return;
        fetchTypeCode();
        fetchOwnerCode();
        fetchCondCode();
        fetchDamageType();
        fetchDestination();
        fetchReceivedBy();
        isMounted.current = true;
    }, []);

    const exportToExcel = async () => {
        // const apiEndPoint = download_sec == 'demurrage' ? 'demurrage-download' : (download_sec == 'inactive' ? 'inactive/download' : DOWNLOADULD);
        if (download_sec == 'period') {
            if (!downloadData.start_date || !downloadData.end_date) {
                toast.error('Please enter start & end Date');
                return;
            }
        }
        let apiEndPoint;
        if (download_sec == 'demurrage') {
            apiEndPoint = 'demurrage-download'
        } else if (download_sec == 'inactive') {
            apiEndPoint = 'inactive/download'
        } else if (download_sec == 'flsch') {
            apiEndPoint = 'flight-schedule/download'
        } else if (download_sec == 'Missing') {
            apiEndPoint = 'recovery/uld-missing-download'
        } else if (download_sec == 'period') {
            apiEndPoint = 'inactive/download-uld-report'
        } else {
            apiEndPoint = DOWNLOADULD
        }
        let payload = {};
        if (download_sec == 'demurrage') {
            payload = { start_date: downloadData.start_date, end_date: downloadData.end_date }
        } else if (download_sec == 'inactive') {
            payload = { tab_name: download_sec, status: downloadData?.status, owner_code: downloadData.owner_code, final_dest: downloadData.final_dest, received_by: downloadData.received_by }
        } else if (download_sec == 'flsch') {
            payload = { tab_name: download_area == 'Active' ? 'A' : 'I', origin: downloadData.origin, destination: downloadData.destination, start_date: downloadData.start_date, end_date: downloadData.end_date }
        } else if (download_sec == 'period') {
            payload = { start_date: downloadData.start_date, end_date: downloadData.end_date }
        } else {
            payload = { tab_name: download_sec, fields: downloadData }
        }
        try {
            const res = await withRFSToken.post(apiEndPoint, payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    },
                    responseType: 'blob', // important for handling binary file download like Excel
                }
            ).then(response => {
                console.log('response', response);

                if (response.status === 200) {
                    const now = new Date();
                    const formattedDateTime = `${String(now.getDate()).padStart(2, '0')}-${String(now.getMonth() + 1).padStart(2, '0')}-${now.getFullYear()} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;

                    const blob = new Blob([response.data], { type: response.headers['content-type'] });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = download_sec == 'inactive' ? 'Inactive ULDs - ' + formattedDateTime + ' Downloaded' : download_sec == 'Active' ? 'Assets - ' + formattedDateTime + ' Downloaded' : download_sec + ' - ' + formattedDateTime + ' Downloaded';
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    handleModalClose();
                } else {toast.error(response.response_msg)}
            })
            if(res.data.response_code === 400) {toast.error(res.data.response_msg)}
            // ).then(function (res) {
            //     if (res.data.response_code == 200) {
            //         const fileUrl = res.data.response_data;
            //         // Create a temporary anchor element
            //         const link = document.createElement('a');
            //         link.href = fileUrl;

            //         // Extract the filename from the URL if needed
            //         const filename = fileUrl.split('/').pop(); // Gets the last part of the URL

            //         // Set the download attribute with the filename
            //         link.setAttribute('download', filename);

            //         // Append the anchor to the body (necessary for the click to work in Firefox)
            //         document.body.appendChild(link);

            //         // Programmatically click the anchor to trigger the download
            //         link.click();

            //         // Clean up by removing the anchor from the DOM
            //         document.body.removeChild(link);
            //         handleModalClose();
            //     } else {
            //         toast.error(res.data.response_msg)
            //     }

            // });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
        onClose();
    };
    return (
        <>{/* console.log('222', downloadData) */}
            <Modal show={isModalOpen} onHide={handleModalClose} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h3>{download_sec == 'period' ? 'Period Overview' : 'Download Filter'}</h3>
                    <p>{download_sec == 'period' ? 'Select a date range to generate the overview.' : 'Download the document as a selected option'}</p>
                    <div className='my-4 '>
                        {download_sec == 'operations' &&
                            <>
                                <Form.Group>
                                    <Col sm="12">
                                        <Form.Label>Flight</Form.Label>
                                        <Select
                                            options={getOwnerCodes}
                                            onChange={(selected) => {
                                                const selectedValues = selected ? selected.map(option => option.value) : [];
                                                setDownloadData({ ...downloadData, flight_prefix: selectedValues });
                                            }}
                                            isMulti
                                            placeholder="Flight Code"
                                            className='down_selct'
                                            name="flight_prefix"
                                            // value={destinationHandler?.filter(handler => downloadData.transfer_by?.includes(handler.id))}
                                            value={options.value}
                                        />

                                    </Col>
                                </Form.Group>
                            </>
                        }
                        {['Active', 'Archived', 'operations', 'Loan', 'Missing'].includes(download_sec) &&
                            <>
                                <Form.Group as={Row}>
                                    <Col sm="12" className='mb-2'>
                                        <Form.Label>Condition Code</Form.Label>
                                        <Select
                                            options={getCondCodes}
                                            placeholder="Condition Code"
                                            className='down_selct'
                                            onChange={(selected) => {
                                                const selectedValues = selected ? selected.map(option => option.value) : [];
                                                setDownloadData({ ...downloadData, condition_code: selectedValues });
                                            }}
                                            isMulti
                                            name="condition_code"
                                            value={options.value}
                                        />
                                    </Col>
                                </Form.Group>
                            </>
                        }
                        {['Active', 'Archived', 'operations', 'Damaged', 'inactive', 'Missing'].includes(download_sec) &&
                            <>
                                <Form.Group as={Row} className='mb-2'>
                                    <Col sm="12">
                                        <Form.Label>Status</Form.Label>
                                        <Select
                                            options={[
                                                { value: '1', label: 'In Operation' },
                                                { value: '3', label: 'In Reserve' },
                                                { value: '4', label: 'On Air' },
                                                { value: '2', label: 'Repair' },
                                                { value: '5', label: 'On Loan' },
                                            ]}
                                            placeholder="Status"
                                            className='down_selct'
                                            onChange={(selected) => {
                                                const selectedValues = selected ? selected.map(option => option.value) : [];
                                                setDownloadData({ ...downloadData, status: selectedValues });
                                                // setDownloadData({ ...downloadData, status: selected.value });
                                            }}
                                            isMulti
                                            name="status"
                                            value={options.value}
                                        />
                                    </Col>
                                </Form.Group>
                            </>
                        }
                        {(download_sec !== 'oa' && download_sec !== 'demurrage' && download_sec !== 'inactive' && download_sec !== 'flsch' && download_sec !== 'period') &&
                            <>
                                <Form.Group as={Row} >
                                    <Col sm="12" className='mb-2'>
                                        <Form.Label>Type Code</Form.Label>
                                        <Select
                                            options={getTypeCodes}
                                            // onChange={(e) => handleDetailsChange(section.uld_number, 'type_code', e.value)}
                                            placeholder="Type Code"
                                            className='down_selct'
                                            onChange={(selected) => {
                                                const selectedValues = selected ? selected.map(option => option.value) : [];
                                                setDownloadData({ ...downloadData, type_code: selectedValues });
                                                // setDownloadData({ ...downloadData, type_code: selected.value });
                                            }}
                                            isMulti
                                            name="type_code"
                                            value={options.value}
                                        // isDisabled={section.reg == 'R' ? true : false}
                                        />
                                    </Col>
                                    <Col sm="12" className='mb-2'>
                                        <Form.Label>Owner Code</Form.Label>
                                        <Select
                                            options={getOwnerCodes}
                                            // onChange={(e) => handleDetailsChange(section.uld_number, 'owner_code', e.value)}
                                            placeholder="Owner Code"
                                            className='down_selct'
                                            onChange={(selected) => {
                                                const selectedValues = selected ? selected.map(option => option.value) : [];
                                                setDownloadData({ ...downloadData, owner_code: selectedValues });
                                                // setDownloadData({ ...downloadData, owner_code: selected.value });
                                            }}
                                            isMulti
                                            name="owner_code"
                                            value={options.value}
                                        // isDisabled={section.reg == 'R' ? true : false}
                                        />
                                    </Col>
                                </Form.Group>
                            </>
                        }
                        {download_sec == 'oa' &&
                            <>
                                <Form.Group as={Row} className='mb-2'>
                                    <Col sm="12">
                                        <Form.Label>Flight Date</Form.Label>
                                        <Form.Control
                                            type="datetime-local"
                                            name='flight_date'
                                            onChange={(e) => setDownloadData({ ...downloadData, flight_date: e.target.value })}
                                        />
                                    </Col>
                                </Form.Group>
                            </>
                        }
                        {['Active', 'Archived', 'operations', 'oa', 'Repair', 'Damaged', 'flsch', 'Missing'].includes(download_sec) &&
                            <>
                                <Form.Group as={Row} className='mb-2'>
                                    <Col sm="12" className='mb-2'>
                                        <Form.Label>Origin</Form.Label>
                                        <Select
                                            options={getDestination}
                                            // onChange={(selected) => {
                                            //     const selectedDestination = getDestination.find(option => option.value === selected.value);

                                            // }}
                                            placeholder="Origin"
                                            className='down_selct'
                                            onChange={(selected) => {
                                                const selectedValues = selected ? selected.map(option => option.value) : [];
                                                setDownloadData({ ...downloadData, origin: selectedValues });
                                                // setDownloadData({ ...downloadData, origin: selected.value });
                                            }}
                                            isMulti
                                            name="origin"
                                            value={options.value}
                                        />
                                    </Col>
                                    <Col sm="12" >
                                        <Form.Label>Destination</Form.Label>
                                        <Select
                                            options={getDestination}
                                            // onChange={(selected) => {
                                            //     const selectedDestination = getDestination.find(option => option.value === selected.value);

                                            // }}
                                            placeholder="Destination"
                                            className='down_selct'
                                            onChange={(selected) => {
                                                const selectedValues = selected ? selected.map(option => option.value) : [];
                                                setDownloadData({ ...downloadData, destination: selectedValues });
                                                // setDownloadData({ ...downloadData, destination: selected.value });
                                            }}
                                            isMulti
                                            name="destination"
                                            value={options.value}
                                        />
                                    </Col>
                                </Form.Group>
                            </>
                        }
                        {download_sec == 'Repair' &&
                            <>
                                <Form.Group as={Row} className='mb-2'>
                                    <Col sm="12">
                                        <Form.Label>Repair In</Form.Label>
                                        <Form.Control
                                            type="datetime-local"
                                            name='repair_in'
                                            onChange={(e) => setDownloadData({ ...downloadData, repair_in: e.target.value })}
                                        />
                                    </Col>
                                </Form.Group>
                            </>
                        }
                        {['Repair', 'Damaged'].includes(download_sec) &&
                            <>
                                <Form.Group as={Row} className='mb-2'>
                                    <Col sm="12">
                                        <Form.Label>Damage Type</Form.Label>
                                        <Select
                                            options={damageType}
                                            onChange={(selected) => {
                                                const selectedValues = selected ? selected.map(option => option.value) : [];
                                                setDownloadData({ ...downloadData, damage_type: selectedValues });
                                                // setDownloadData({ ...downloadData, destination: selected.value });
                                            }}
                                            placeholder="Damage Type"
                                            className='down_selct'
                                            name="damage_type"
                                            value={options.value}
                                        />
                                    </Col>
                                </Form.Group>
                            </>
                        }
                        {download_sec == 'Discarded' &&
                            <>
                                <Form.Group as={Row} className='mb-2'>
                                    <Col sm="12">
                                        <Form.Label>Discarded Date</Form.Label>
                                        <Form.Control
                                            type="datetime-local"
                                            name='repair_in'
                                            onChange={(e) => setDownloadData({ ...downloadData, repair_in: e.target.value })}
                                        />
                                    </Col>
                                </Form.Group>
                            </>
                        }
                        {download_sec == 'Loan' &&
                            <>
                                <Form.Group as={Row} className='mb-2'>
                                    <Col sm="12" className='mb-2'>
                                        <Form.Label>LUC Out</Form.Label>
                                        <Form.Control
                                            type="datetime-local"
                                            name='luc_out'
                                            onChange={(e) => setDownloadData({ ...downloadData, luc_out: e.target.value })}
                                        />
                                    </Col>
                                    <Col sm="12" className='mb-2'>
                                        <Form.Label>Transfer Point</Form.Label>
                                        <Select
                                            options={getTransfer}
                                            // onChange={(selected) => {
                                            //     const selectedDestination = getDestination.find(option => option.value === selected.value);

                                            // }}
                                            placeholder="Transfer Point"
                                            className='down_selct'
                                            onChange={(selected) => {
                                                const selectedValues = selected ? selected.map(option => option.value) : [];
                                                console.log("🚀 ~ DownloadGrid ~ selectedValues:", selectedValues)
                                                setDownloadData({ ...downloadData, transfer_point: selectedValues });
                                                // setDownloadData({ ...downloadData, origin: selected.value });
                                                const selectedDestination = selected
                                                    ? selected.flatMap(option => {
                                                        const destination = getDestination.find(dest => dest.value === option.value);
                                                        return destination ? destination.address : [];
                                                    })
                                                    : [];
                                                // setDestinationHandler(selectedDestination ? selectedDestination.address : []);
                                                setTransferHandler(selectedDestination);
                                            }}
                                            isMulti
                                            name="transfer_point"
                                            value={options.value}
                                        />
                                    </Col>
                                    {/* <Col sm="12">
                                        <Form.Label>Transferred By</Form.Label>
                                        <Select
                                            options={transferHandler?.map(handler => ({
                                                value: handler.id,
                                                label: handler.company_name
                                            }))}
                                            onChange={(selected) => {
                                                const selectedValues = selected ? selected.map(option => option.value) : [];
                                                setDownloadData({ ...downloadData, transfer_by: selectedValues });
                                            }}
                                            isMulti
                                            placeholder="Agent Name"
                                            className='down_selct'
                                            name="transfer_by"
                                            // value={destinationHandler?.filter(handler => downloadData?.transfer_by?.includes(handler.id))}
                                            value={options.value}
                                        />
                                    </Col> */}
                                    <Col sm="12" className='mb-2'>
                                        <Form.Label>Final Destination</Form.Label>
                                        <Select
                                            options={getDestination}
                                            // onChange={(selected) => {
                                            //     const selectedDestination = getDestination.find(option => option.value === selected.value);

                                            // }}
                                            placeholder="Final Destination"
                                            className='down_selct'
                                            onChange={(selected) => {
                                                const selectedValues = selected ? selected.map(option => option.value) : [];
                                                setDownloadData({ ...downloadData, final_dest: selectedValues });
                                                // setDownloadData({ ...downloadData, origin: selected.value });

                                                // const selectedDestination = selected
                                                //     ? selected.flatMap(option => {
                                                //         const destination = getDestination.find(dest => dest.value === option.value);
                                                //         return destination ? destination.address : [];
                                                //     })
                                                //     : [];
                                                // console.log("🚀 ~ DownloadGrid ~ selectedDestination:", selectedDestination)
                                                // setDestinationHandler(selectedDestination ? selectedDestination.address : []);
                                                // setDestinationHandler(selectedDestination);

                                            }}
                                            isMulti
                                            name="final_dest"
                                            value={options.value}
                                        />
                                    </Col>
                                    {/* <Col sm="12">
                                        <Form.Label>Received By</Form.Label>
                                        <Select
                                            options={destinationHandler}
                                            onChange={(selected) => {
                                                const selectedValues = selected ? selected.map(option => option.value) : [];
                                                setDownloadData({ ...downloadData, received_by: selectedValues });
                                            }}
                                            isMulti
                                            placeholder="Agent Name"
                                            className='down_selct'
                                            name="transfer_by"
                                            // value={destinationHandler?.filter(handler => downloadData.transfer_by?.includes(handler.id))}
                                            value={options.value}
                                        />

                                    </Col> */}
                                </Form.Group>
                            </>
                        }

                        {download_sec == 'inactive' &&
                            <>
                                <Form.Group as={Row} className='pe-0'>
                                    {/* <Col sm="12" className='mb-2'>
                                    <Form.Label>Destination</Form.Label>
                                        <Select
                                            options={getDestination}
                                            // onChange={(selected) => {
                                            //     const selectedDestination = getDestination.find(option => option.value === selected.value);

                                            // }}
                                            placeholder="Destination"
                                            className='down_selct'
                                            onChange={(selected) => {
                                                const selectedValues = selected ? selected.map(option => option.value) : [];
                                                setDownloadData({ ...downloadData, destination: selectedValues });
                                                // setDownloadData({ ...downloadData, destination: selected.value });
                                            }}
                                            isMulti
                                            name="destination"
                                            value={options.value}
                                        />
                                    </Col> */}

                                    <Col sm="12" className='mb-2'>
                                        <Form.Label>Owner Code</Form.Label>
                                        <Select
                                            options={getOwnerCodes}
                                            // onChange={(e) => handleDetailsChange(section.uld_number, 'owner_code', e.value)}
                                            placeholder="Owner Code"
                                            className='down_selct'
                                            onChange={(selected) => {
                                                const selectedValues = selected ? selected.map(option => option.value) : [];
                                                setDownloadData({ ...downloadData, owner_code: selectedValues });
                                                // setDownloadData({ ...downloadData, owner_code: selected.value });
                                            }}
                                            isMulti
                                            name="owner_code"
                                            value={options.value}
                                        // isDisabled={section.reg == 'R' ? true : false}
                                        />
                                    </Col>

                                    <Col sm="12" className='mb-2'>
                                        <Form.Label>Final Destination</Form.Label>
                                        <Select
                                            options={getDestination}
                                            placeholder="Final Destination"
                                            className='down_selct'
                                            onChange={(selected) => {
                                                const selectedValues = selected ? selected.map(option => option.value) : [];
                                                setDownloadData({ ...downloadData, final_dest: selectedValues });
                                            }}
                                            isMulti
                                            name="final_dest"
                                            value={options.value}
                                        />
                                    </Col>
                                </Form.Group>
                            </>
                        }

                        {(download_sec == 'Loan' || download_sec == 'operations' || download_sec == 'inactive') &&
                            <>
                                <Form.Group>
                                    <Col sm="12">
                                        <Form.Label>Received By</Form.Label>
                                        <Select
                                            options={destinationHandler}
                                            onChange={(selected) => {
                                                const selectedValues = selected ? selected.map(option => option.value) : [];
                                                setDownloadData({ ...downloadData, received_by: selectedValues });
                                            }}
                                            isMulti
                                            placeholder="Agent Name"
                                            className='down_selct'
                                            name="transfer_by"
                                            // value={destinationHandler?.filter(handler => downloadData.transfer_by?.includes(handler.id))}
                                            value={options.value}
                                        />

                                    </Col>
                                </Form.Group>
                            </>
                        }

                        {(download_sec == 'demurrage' || download_sec == 'flsch') &&
                            <>
                                <Form.Group as={Row} className='pe-0'>
                                    <Col sm="6" className='mb-2'>
                                        <Form.Label>Start Date</Form.Label>
                                        <Form.Control
                                            type="datetime-local"
                                            name="start_date"
                                            onChange={(event) => {
                                                const startDate = event.target.value;  // Get selected start date
                                                setDownloadData({ ...downloadData, start_date: startDate });  // Update state
                                            }}
                                            value={downloadData.start_date}  // Bind the start date to the state
                                            placeholder="Start Date"
                                        />
                                    </Col>
                                    <Col sm="6" className='mb-2 pe-0'>
                                        <Form.Label>End Date</Form.Label>
                                        <Form.Control
                                            type="datetime-local"
                                            name="end_date"
                                            onChange={(event) => {
                                                const endDate = event.target.value;  // Get selected end date
                                                setDownloadData({ ...downloadData, end_date: endDate });  // Update state
                                            }}
                                            value={downloadData.end_date}  // Bind the end date to the state
                                            placeholder="End Date"
                                        />
                                    </Col>
                                </Form.Group>
                            </>
                        }

                        {download_sec == 'period' &&
                            <>
                                <Form.Group as={Row} className='mb-2'>
                                    <Col sm="12">
                                        <Form.Label>Start Date<span>*</span></Form.Label>
                                        <Form.Control
                                            type="datetime-local"
                                            name='start_date'
                                            onChange={(e) => setDownloadData({ ...downloadData, start_date: e.target.value })}
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className='mb-2'>
                                    <Col sm="12">
                                        <Form.Label>End Date<span>*</span></Form.Label>
                                        <Form.Control
                                            type="datetime-local"
                                            name='end_date'
                                            onChange={(e) => setDownloadData({ ...downloadData, end_date: e.target.value })}
                                        />
                                    </Col>
                                </Form.Group>
                            </>
                        }

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={exportToExcel}>
                        Download
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default DownloadGrid;